<script lang="ts">
    import {Divider, Flex} from 'shared/layouts';
    import {getInjector} from 'src/core';
    import {DurationItemFormat} from 'src/features/erp-sutor/features/attendance-calendar';
    import {LabeledValue} from 'src/features/erp-sutor/shared';
    import type {RecordRow} from 'src/features/record-grid/lib/types';
    import type {AllDayReportsHoursSum} from '../types';
    import {onMount} from 'svelte';
    import {ReportDetailService} from '../report-detail.service';
    import {exists} from 'shared/utils/custom-utils';
    import KpBarebonesTable from 'shared/ui-widgets/table/barebones/KpBarebonesTable.svelte';

    export let record: RecordRow;

    const service = getInjector().getByClass(ReportDetailService);

    let loading = true;
    let allDayReportsHoursSum: AllDayReportsHoursSum | null = null;

    onMount(async () => {
        allDayReportsHoursSum = await service.getAllDayReportsHoursSum(record);
        loading = false;
    });
</script>

{#if !loading && exists(allDayReportsHoursSum)}
    <LabeledValue withoutBiggerValueText
                  fillWidth
                  additionalClasses="report-same-day-report-hours-sum"
                  label="Součet hodin všech výkazů pracovníka zadaných v rámci stejného dne">

        <Flex direction="column" gap="sm">
            <KpBarebonesTable additionalClasses="report-same-day-report-hours-sum-table">
                <tr slot="header">
                    <th>Denní fond</th>
                    <th>Standard</th>
                    <th>Přesčas</th>
                    <th>Absence</th>
                    <th>Pohotovost</th>
                </tr>

                <svelte:fragment slot="body">
                    <tr>
                        <td>
                            <DurationItemFormat durationItem={allDayReportsHoursSum.commitment}/>
                        </td>

                        <td>
                            <DurationItemFormat durationItem={allDayReportsHoursSum.work}/>
                        </td>

                        <td>
                            <DurationItemFormat durationItem={allDayReportsHoursSum.overtime}/>
                        </td>

                        <td>
                            <DurationItemFormat durationItem={allDayReportsHoursSum.absence}/>
                        </td>

                        <td>
                            <DurationItemFormat durationItem={allDayReportsHoursSum.onCallDuty}/>
                        </td>
                    </tr>
                </svelte:fragment>
            </KpBarebonesTable>

            <Divider direction="horizontal" size="100%"/>

            <Flex direction="row" gap="m" alignItems="center" justifyContent="space-between">
                <span class="sum-text">Celkem</span>
                <DurationItemFormat durationItem={allDayReportsHoursSum.sum}/>
            </Flex>
        </Flex>
    </LabeledValue>
{/if}

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    .sum-text {
        font-weight: 500;
    }

    :global {
        .report-same-day-report-hours-sum {
            padding: @spacing-sm @spacing-m;
            border-radius: @border-radius-large;
            background-color: @themed-body-bg-yellow-highlighted;
        }

        .report-same-day-report-hours-sum-table {
            thead th {
                padding-bottom: 0 !important;
                padding-top: @spacing-xs !important;
            }

            tbody td {
                padding-top: @spacing-s !important;
                padding-bottom: @spacing-xs !important;
            }
        }
    }
</style>